import { render, staticRenderFns } from "./performDisconnection.vue?vue&type=template&id=60927461"
import script from "./performDisconnection.ts?vue&type=script&lang=js&external"
export * from "./performDisconnection.ts?vue&type=script&lang=js&external"
import style0 from "./performDisconnection.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports